import { SegmentKey, MarketPlace } from '@amzn/fire-tv-campaign-automation-service';
import { STAGE } from 'src/constants';

import betaTargetSegments from '../data/TargetSegments/targetSegments_beta.json';
import gammaTargetSegments from '../data/TargetSegments/targetSegments_gamma.json';
import prodFeTargetSegments from '../data/TargetSegments/targetSegments_prod-fe.json';
import prodNaTargetSegments from '../data/TargetSegments/targetSegments_prod-na.json';

export interface TargetingConfig {
  name: string;
  id: string;
}

type MarketplaceTargetSegments = Partial<
  Record<MarketPlace, Partial<Record<SegmentKey, TargetingConfig[]>>>
>;

const targetSegmentsByStage: Record<STAGE, MarketplaceTargetSegments> = {
  [STAGE.DEV]: betaTargetSegments as MarketplaceTargetSegments,
  [STAGE.BETA]: betaTargetSegments as MarketplaceTargetSegments,
  [STAGE.GAMMA]: gammaTargetSegments as MarketplaceTargetSegments,
  [STAGE.PROD_NA]: prodNaTargetSegments as MarketplaceTargetSegments,
  [STAGE.PROD_FE]: prodFeTargetSegments as MarketplaceTargetSegments,
};

export const getTargetSegmentConfiguration = (
  stage: STAGE,
  marketplace: MarketPlace,
): Partial<Record<SegmentKey, TargetingConfig[]>> => {
  const stageData = targetSegmentsByStage[stage];
  if (!stageData) {
    return {};
  }

  const marketplaceData = stageData[marketplace];
  if (!marketplaceData) {
    return {};
  }

  return marketplaceData;
};
